import React from 'react';
import PropTypes from 'prop-types';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import FormGroup from '@spothero/ui/form-group';
import Image from 'common/image/Image';
import TextInput from '@spothero/ui/text-input';
import AppStoreBadges from 'common/apps/AppStoreBadges';
import WithBranchTextApp from 'common/branch/WithBranchTextApp';

const HomeAppPromo = ({email, isSubmitting, onSubmit}) => {
    return (
        <div className="HomeAppPromo">
            <h1 className="Home-heading">Get the #1 Rated App Now!</h1>
            <p>
                Enter your phone number below and you will receive a one-time
                text message to download the free SpotHero parking app.
            </p>
            <Form id="HomeAppPromo-form" onSubmit={onSubmit}>
                <FormGroup>
                    <TextInput
                        name="phone"
                        placeholder="Enter phone number"
                        mask="(999) 999-9999"
                        error={
                            <FormElementError>
                                Please enter a valid email.
                            </FormElementError>
                        }
                        required
                    />
                    <Button
                        type="submit"
                        color="primary"
                        loading={isSubmitting}
                        disabled={isSubmitting}
                    >
                        Text me the app
                    </Button>
                </FormGroup>
            </Form>
            <small>
                By entering your phone number and clicking above, you consent
                and authorize SpotHero to send you a one-time text message
                through an automatic telephone dialing system. Message &amp;
                data rates may apply.
            </small>
            <AppStoreBadges email={email} width={188} height={55} />
            <Image
                className="HomeAppPromo-phone"
                width={249}
                height={526}
                cloudinaryImageId="homepage/home-apps"
                alt="Download the SpotHero app today!"
                lazyLoad
            />
        </div>
    );
};

HomeAppPromo.propTypes = {
    email: PropTypes.string,
    isSubmitting: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
};

export default WithBranchTextApp(HomeAppPromo);
